import React from "react";
import { BackIcon } from '@/components/common/icons';
import { useHistory } from 'react-router-dom';

const BackBtn = props => {
    let history = useHistory();
    let show = localStorage.getItem("back-btn");
    return (show==="true"?<BackIcon style={{marginRight:"13px"}} onClick={()=>{
        localStorage.setItem("back-btn",false);
        if(props.url){
            history.push(props.url)
        }else{
            history.goBack()
        }
    }} />:null)
}

export default BackBtn;